
// Rule of Level DAO
var DAO_LEVEL_TABLE = {
  "10": 100000000,
  "9": 50000000,
  "8": 10000000,
  "7": 5000000,
  "6": 1000000,
  "5": 500000,
  "4": 100000,
  "3": 10000,
  "2": 1000,
  "1": 99,
}

module.exports = {
  "daolevel": DAO_LEVEL_TABLE
}


// WEBPACK FOOTER //
// ./src/settings.js